import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('PeppolDA', PeppolDA);

    PeppolDA.$inject = ['Restangular', 'CONF'];

    /**
     * Class permettant la manipulation des infos relatives aux sociétés.
     */

    /* @ngInject */
    function PeppolDA(Restangular, CONF) {
        var baseUrl = CONF.apiBaseUrl + '/v1/peppol';

        var exports = {
            getPeppolTypeIdentifierByCountry:getPeppolTypeIdentifierByCountry
        };

        return exports;


        function getPeppolTypeIdentifierByCountry(country){
            return Restangular.one(baseUrl+'/type-identifier/'+ country)
                .get()
                .then(function (data) {
                    return data;
                });
        }
    }

})();
